module.exports = __webpack_public_path__ + "img/106c65b.png";